import React, { useState, useEffect } from "react";
import { Box, Paper, Select, MenuItem, FormControl, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import getLearningPathData from "./api";
import LearningPathProgressDisplay from "../../dashboard/dashboardLiast";
import { IoTdevelopercourses, IoTDataScientistcourses, IndustrialiotCourses } from "../Courses/coursesdata";
import { IoTdeveloperProjects, IoTDataScientistProjects, IndustrialProjects } from "../Courses/projectsData";

const LearningPathData = () => {
  const [selectedOption, setSelectedOption] = useState(localStorage.getItem("selectedLearningPath") || "");
  const [responseData, setResponseData] = useState({
    HOE: 0,
    learningPathProgress: 0,
    totalCoursesProgress: 0,
    totalProjectsProgress: 0,
  });

  const options = [
    'IoT Developer / Engineer',
    'IoT Data Scientist',
    'Industrial IoT & Industry 4.0',
  ];

  // Fetch API data when the selection changes
  useEffect(() => {
  if (selectedOption) {
    let selectedData = { courses: [], projects: [] };

    switch (selectedOption) {
      case "IoT Developer / Engineer":
        selectedData = {
          courses: IoTdevelopercourses[0]?.courses || [],
          projects: IoTdeveloperProjects[0]?.projects || [],
        };
        break;
      case "IoT Data Scientist":
        selectedData = {
          courses: IoTDataScientistcourses[0]?.courses || [],
          projects: IoTDataScientistProjects[0]?.projects || [],
        };
        break;
      case "Industrial IoT & Industry 4.0":
        selectedData = {
          courses: IndustrialiotCourses[0]?.courses || [],
          projects: IndustrialProjects[0]?.projects || [],
        };
        break;
      default:
        console.error("Invalid Learning Path Selection");
        return;
    }

    getLearningPathData(selectedOption, selectedData.courses, selectedData.projects, setResponseData)
      .then(() => {
        console.log("API Call Successful");
      })
      .catch((error) => {
        console.error("API Call Failed:", error);
      });
  }
}, [selectedOption]);

// Log responseData separately to track updates
useEffect(() => {
  //console.log("Updated responseData:", responseData);
}, [responseData]); 

  const handleChange = (event) => {
    const selected = event.target.value;
    setSelectedOption(selected);
    localStorage.setItem("selectedLearningPath", selected);
    //console.log(`Selected Learning Path: ${selected}`);
  };

  const DropdownIcon = (props) => (
  <FontAwesomeIcon icon={faChevronDown} {...props} style={{ color: "#043885" }} />
  );

  return (
     <Box sx={{margin:"40px 30px 10px 30px", justifyContent:"center", alignItems:"center"}}>
      <Paper
        elevation={0}
        sx={{
          width : "100%",
          borderRadius: 3,
          backgroundColor: "#f9fbfd",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.08)",
          padding: "14px 20px 20px 20px",
        }}
      >
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Box
          sx={{
            backgroundColor: "#E3F2FD",
            color: "#043885",
            borderRadius: "50%",
          }}
        >
          <i className="fas fa-bullseye" style={{ fontSize: 20 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#052659",
          }}
        >
          Choose your Learning Path
        </Typography>
      </Box>

      <FormControl fullWidth variant="outlined">
       <Select
        displayEmpty
        value={selectedOption}
        onChange={handleChange}
        IconComponent={DropdownIcon}
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          fontSize: "1rem",
          height : 48,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
          "& fieldset": {
            border: "1px solid #e0e0e0",
          },
          "&:hover fieldset": {
            borderColor: "#043885",
          },
        }}
      >
        <MenuItem disabled value="">
          -- Select --
        </MenuItem>
        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={option}
            sx={{
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
      </FormControl>
    </Paper>
    {selectedOption && (
      <Box mt={4}>
        <LearningPathProgressDisplay
          selectedOption={selectedOption}
          responseData={responseData}
        />
      </Box>
    )}
  </Box>
  );
};

export default LearningPathData;